import React from 'react';
import * as s from './styled-chart-subtitle';

function ChartSubtitle({ title, color }) {
	return <s.Subtitle color={color}>{title}</s.Subtitle>;
}

export default ChartSubtitle;
